import { create } from "zustand";

interface RevenueEachMonthState {
  accountId: any;
  year: any;
  setAccountId: (accountId: any) => void;
  setYear: (startDate: any) => void;
}

export const useRevenueEachMonth = create<RevenueEachMonthState>((set) => ({
  accountId: undefined,
  year: undefined,
  setAccountId: (accountId) => set({ accountId }),
  setYear: (year) => set({ year: +year }),
}));
